import { Wrapper } from './components/common/Wrapper/Wrapper';
import { MainLayout } from './layout/MainLayout';
import './i18n/i18n';

function App() {
  return (
    <Wrapper>
      <MainLayout />
    </Wrapper>
  );
}

export default App;
